import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface StepData {
  step: number;
  formData: Record<string, any>;
}

interface ITInFormState {
  currentStep: number;
  stepsData: Record<number, StepData>;
}

const initialState: ITInFormState = {
  currentStep: 1,
  stepsData: {},
};

const itinFormSlice = createSlice({
  name: "itinForm",
  initialState,
  reducers: {
    setStepData: (state, action: PayloadAction<{ step: number; data: any }>) => {
      state.stepsData[action.payload.step] = {
        step: action.payload.step,
        formData: action.payload.data,
      };
    },
    
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
  },
});

export const { setStepData, setCurrentStep } = itinFormSlice.actions;
export default itinFormSlice.reducer;


